var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.093 13.25.57-3.619h-3.51V7.28c0-.99.49-1.956 2.057-1.956h1.618v-3.08A19.635 19.635 0 0 0 14.978 2c-2.889 0-4.775 1.735-4.775 4.873V9.63H7v3.618h3.203V22h3.95v-8.75h2.94Z"
  })));
};
export default SvgFacebook;